import { render, staticRenderFns } from "./ProjetoRNLista.vue?vue&type=template&id=48057094&"
import script from "./ProjetoRNLista.vue?vue&type=script&lang=js&"
export * from "./ProjetoRNLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports